import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.date.to-string.js";
import * as React from 'react';
import useCountriesHook from "../../hooks/useCountries";
import useEducationHistory from "./useEducationHistory";
import { LEVELS_MAP_NUMBER_TO_CONST } from "./consts";
function mapCountryCodeToName(countries, code) {
  var country = countries.find(function (country) {
    return country.code === code;
  });
  return country ? country.name : code;
}
var extractPersonalInformation = function extractPersonalInformation(application, countries) {
  return {
    firstName: application.student.personal_information.first_name,
    lastName: application.student.personal_information.last_name,
    middleName: application.student.personal_information.middle_name,
    dateOfBirth: application.student.personal_information.birthdate,
    firstLanguage: application.student.personal_information.first_language,
    countryOfCitizenship: mapCountryCodeToName(countries, application.student.personal_information.country_of_citizenship),
    passportNumber: application.student.personal_information.passport_number,
    gender: application.student.personal_information.gender,
    maritalStatus: application.student.personal_information.marital_status
  };
};
var extractBackgroundInformation = function extractBackgroundInformation(application) {
  return {
    validAustraliaStudyVisaOrVisitorVisa: !!application.student.background_information.has_au_study_permit,
    validCanadianStudyPermitOrVisitorVisa: !!application.student.background_information.has_ca_study_permit,
    validUKStudyVisaOrVisitorVisa: !!application.student.background_information.has_uk_study_permit,
    validUSStudyVisaOrVisitorVisa: !!application.student.background_information.has_us_study_permit,
    validIrelandStudyVisaOrVisitorVisa: !!application.student.background_information.has_ie_study_permit,
    informationText: application && application.student && application.student.background_information && application.student.background_information.information_text ? application.student.background_information.information_text : '',
    removedFromCanadaUSAOrAnyOtherCountry: !!application.student.background_information.prior_removal,
    visitedCanadaUSABefore: !!application.student.background_information.prior_visit,
    refusedVisaForCanadaUSAOrAnyOtherCountry: !!application.student.background_information.refusal_of_entry,
    // residing: !!application.student.background_information.residing,
    appliedForAnyTypeImmigrationIntoCanadaUSA: !!application.student.background_information.prior_immigration_application
  };
};
var extractAddressDetail = function extractAddressDetail(application, countries) {
  return {
    address: application.student.residential_address.address.street,
    city: application.student.residential_address.address.city,
    country: mapCountryCodeToName(countries, application.student.residential_address.address.country),
    phoneNumber: application.student.personal_information.phone,
    postalZipCode: application.student.residential_address.address.postal,
    provinceState: application.student.residential_address.address.province
  };
};
var extractEducationSummary = function extractEducationSummary(application, countries) {
  return {
    convertedGrade: String(application.student.education_summary.converted_grade),
    countryOfEducation: mapCountryCodeToName(countries, application.student.education_summary.education_country),
    grade: String(application.student.education_summary.grade),
    gradeScale: application.student.education_summary.grade_scale,
    gradingScheme: String(application.student.education_summary.grading_scheme),
    graduatedFromMostRecentSchool: application.student.education_summary.graduated,
    highestLevelOfEducation: application.student.education_summary.studied_level
  };
};
var extractSchoolsAttended = function extractSchoolsAttended(application, educationHistory) {
  return educationHistory.map(function (attendedSchool) {
    return {
      id: Number(attendedSchool.id),
      dateDegreeAwarded: attendedSchool.attributes.date_degree_awarded,
      degreeName: attendedSchool.attributes.degree_name || '',
      endDate: attendedSchool.attributes.end_date,
      language: attendedSchool.attributes.language,
      level: LEVELS_MAP_NUMBER_TO_CONST[attendedSchool.attributes.level] ? LEVELS_MAP_NUMBER_TO_CONST[attendedSchool.attributes.level] : attendedSchool.attributes.level,
      schoolName: attendedSchool.attributes.school_name,
      startDate: attendedSchool.attributes.start_date
    };
  });
};
var extractStatus = function extractStatus(application) {
  var data = {
    accepted: !!application.status.accepted,
    rejected: !!application.status.rejected,
    canceled: !!application.status.canceled,
    withdrawn: !!application.status.withdrawn,
    submitted: !!application.status.submitted,
    readyToSubmit: !!application.status.ready_to_submit,
    readyForVisa: !!application.status.ready_for_visa
  };
  return data;
};
var extractProgramInformation = function extractProgramInformation(application) {
  var applicationFee = application.service_charges && application.service_charges.find(function (charge) {
    return charge.title === 'Application Fee';
  });
  return {
    id: application.program.id,
    name: application.program.name,
    level: application.program.level,
    applicationFee: applicationFee ? Number(applicationFee.price) : undefined,
    educationalInstitution: {
      id: application.school.id,
      name: application.school.name
    }
  };
};
var extractEnglishExamInformation = function extractEnglishExamInformation(application) {
  var type = application.student && application.student.test_scores && application.student.test_scores.english_exam_type;
  if (!type) {
    return [];
  }
  if (application.student.test_scores[type]) {
    var exam = application.student.test_scores[type];
    return [{
      type: type,
      examDate: exam.exam_date,
      scores: {
        listening: exam.listening,
        reading: exam.reading,
        writing: exam.writing,
        speaking: exam.speaking
      }
    }];
  }
  return [];
};
var extractGreExamInformation = function extractGreExamInformation(application) {
  var exam = application.student.additional_qualifications.gre;
  if (!exam) return [];
  return [{
    examDate: exam.exam_date,
    completed: true,
    scores: {
      verbal: Number(exam.verbal_score),
      quantitative: Number(exam.quantitative_score),
      writing: Number(exam.writing_score)
    },
    additionalInformation: {
      percentile: {
        verbal: Number(exam.verbal_rank),
        quantitative: Number(exam.quantitative_rank),
        writing: Number(exam.writing_rank)
      },
      verbalQuantitativeCombined: null
    }
  }];
};
var extractGmatExamInformation = function extractGmatExamInformation(application) {
  var exam = application.student.additional_qualifications.gmat;
  if (!exam) return [];
  return [{
    examDate: exam.exam_date,
    completed: true,
    scores: {
      verbal: Number(exam.verbal_score),
      quantitative: Number(exam.quantitative_score),
      writing: Number(exam.writing_score),
      total: Number(exam.total_score)
    },
    additionalInformation: {
      percentile: {
        verbal: Number(exam.verbal_rank),
        quantitative: Number(exam.quantitative_rank),
        writing: Number(exam.writing_rank),
        total: Number(exam.total_rank)
      }
    }
  }];
};
var extractExamInformation = function extractExamInformation(application) {
  return {
    englishExams: extractEnglishExamInformation(application),
    gre: extractGreExamInformation(application),
    gmat: extractGmatExamInformation(application)
  };
};
var useApplicationAsSnapshot = function useApplicationAsSnapshot(application) {
  var countries = useCountriesHook();
  var educationHistory = useEducationHistory();
  return React.useMemo(function () {
    return countries && educationHistory ? {
      type: '',
      programApplication: {
        id: application.id,
        paid: application.paid,
        status: extractStatus(application),
        applicant: {
          id: application.student.id,
          email: application.student.email,
          username: '',
          personalInformation: extractPersonalInformation(application, countries),
          addressDetail: extractAddressDetail(application, countries),
          educationSummary: extractEducationSummary(application, countries),
          schoolsAttended: extractSchoolsAttended(application, educationHistory),
          backgroundInformation: extractBackgroundInformation(application),
          exams: extractExamInformation(application)
        },
        program: extractProgramInformation(application),
        createdAt: new Date().toISOString()
      },
      additionalSnapshotAttributes: {},
      revisionAt: '',
      version: 1
    } : null;
  }, [countries, educationHistory, application]);
};
export default useApplicationAsSnapshot;